"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var airports_1 = require("./airports");
var selection_1 = require("./selection");
var master_data_1 = require("./master_data");
// import data from an API response
function IMPORT(state, data) {
    state.flights = data;
}
exports.IMPORT = IMPORT;
// cache the last request signature to prevent concurrency issues
function SET_LOADING(state, key) {
    state.loading = key;
}
exports.SET_LOADING = SET_LOADING;
// select an airport from the flex airports list
function SELECT_AIRPORT(state, code) {
    if (!!state.airports) {
        var airport = state.airports.list.find(function (airport) { return airport.locCd === code; });
        state.selectedFilters.airport = !!airport ? airport : null;
    }
    else {
        state.selectedFilters.airport = null;
    }
}
exports.SELECT_AIRPORT = SELECT_AIRPORT;
// select a flight using its id code
function SELECT_FLIGHT(state, code) {
    state.flightSelection.selected = code;
    state.priceDiffer = 0;
}
exports.SELECT_FLIGHT = SELECT_FLIGHT;
// select a flight class
function SELECT_FLIGHT_CLASS(state, code) {
    state.selectedFilters.flightClass = code;
}
exports.SELECT_FLIGHT_CLASS = SELECT_FLIGHT_CLASS;
// select a flight direction
function SELECT_FLIGHT_DIRECTION(state, code) {
    state.selectedFilters.flightDirection = code;
}
exports.SELECT_FLIGHT_DIRECTION = SELECT_FLIGHT_DIRECTION;
function SET_OR_TOGGLE_AIRLINE_CODE(state, inputAirline) {
    var _a, _b, _c;
    var selectedCodes = state.selectedFilters.airlineCodes;
    var alreadySelected = selectedCodes.includes((_a = inputAirline) === null || _a === void 0 ? void 0 : _a.code);
    // if select is not given, toggle selection
    var selectAirline = (_c = (_b = inputAirline) === null || _b === void 0 ? void 0 : _b.select, (_c !== null && _c !== void 0 ? _c : !alreadySelected));
    var change = selectAirline !== alreadySelected;
    if (!change || !inputAirline || !inputAirline.code)
        return;
    if (!selectAirline) {
        state.selectedFilters.airlineCodes =
            selectedCodes.filter(function (selected) { return selected !== inputAirline.code; });
    }
    else if (selectedCodes.length < master_data_1.default.maxSelectableAirlinesCount
        && master_data_1.default.flexFlightAirlines.some(function (airline) { return airline.code === inputAirline.code; })) {
        state.selectedFilters.airlineCodes.push(inputAirline.code);
    }
}
exports.SET_OR_TOGGLE_AIRLINE_CODE = SET_OR_TOGGLE_AIRLINE_CODE;
function SET_NONSTOP(state, nonstop) {
    state.selectedFilters.nonstop = nonstop;
}
exports.SET_NONSTOP = SET_NONSTOP;
function IMPORT_AIRPORTS(state, airports) {
    state.airports = new airports_1.Airports(airports);
}
exports.IMPORT_AIRPORTS = IMPORT_AIRPORTS;
function SET_GATEWAYS_CACHE_FOR(state, data) {
    if (!data || !data.priceModel || !data.gateways || !data.gateways.length)
        return;
    state.cachedGateways[data.priceModel] = data.gateways;
}
exports.SET_GATEWAYS_CACHE_FOR = SET_GATEWAYS_CACHE_FOR;
function SET_FETCH_TIME(state, time) {
    state.fetchTime = time;
}
exports.SET_FETCH_TIME = SET_FETCH_TIME;
function SET_STEP(state, step) {
    for (var key in state.steps) {
        state.steps[key] = !!(key === step);
    }
}
exports.SET_STEP = SET_STEP;
function RESET_SELECTED_FLIGHT(state) {
    state.flightSelection = new selection_1.Selection();
    state.priceDiffer = 0;
}
exports.RESET_SELECTED_FLIGHT = RESET_SELECTED_FLIGHT;
function RESET_STATE(state) {
    state.flights = [];
    state.cachedGateways = {};
    state.loading = '';
    state.flightSelection = new selection_1.Selection();
    state.fetchTime = 0;
    state.priceDiffer = 0;
    state.selectedFilters = {
        airlineCodes: [],
        airport: null,
        flightClass: null,
        flightDirection: null,
        nonstop: false
    };
    state.steps = {
        flexInfo: true,
        flexSearch: false,
        flexFlights: false,
        flexRNF: false
    };
    state.rnfDeparture = false;
    state.rnfArrival = false;
    state.rnfCategory = '2';
    state.rnfTotalPrice = 0;
    state.rnfTransportations = [];
}
exports.RESET_STATE = RESET_STATE;
function RESET_RNF_STATE(state) {
    state.rnfDeparture = false;
    state.rnfArrival = false;
    state.rnfCategory = '2';
    state.rnfTotalPrice = 0;
    state.rnfTransportations = [];
}
exports.RESET_RNF_STATE = RESET_RNF_STATE;
function RESET_STATE_TO_CHOOSE_STEP(state) {
    state.flights = [];
    state.loading = '';
    state.flightSelection = new selection_1.Selection();
    state.fetchTime = 0;
    state.priceDiffer = 0;
    state.steps = {
        flexInfo: false,
        flexSearch: true,
        flexFlights: false,
        flexRNF: false
    };
    state.rnfDeparture = false;
    state.rnfArrival = false;
    state.rnfCategory = '2';
    state.rnfTotalPrice = 0;
    state.rnfTransportations = [];
}
exports.RESET_STATE_TO_CHOOSE_STEP = RESET_STATE_TO_CHOOSE_STEP;
function SET_RNF_DEPARTURE(state, data) {
    state.rnfDeparture = data;
}
exports.SET_RNF_DEPARTURE = SET_RNF_DEPARTURE;
function SET_RNF_ARRIVAL(state, data) {
    state.rnfArrival = data;
}
exports.SET_RNF_ARRIVAL = SET_RNF_ARRIVAL;
function SET_RNF_CATEGORY(state, data) {
    // validate data
    if (data !== '1')
        data = '2';
    state.rnfCategory = data;
}
exports.SET_RNF_CATEGORY = SET_RNF_CATEGORY;
function SET_TRANSPORTATION(state, data) {
    state.rnfTransportations = data;
    SET_RNF_TOTAL_PRICE(state);
}
exports.SET_TRANSPORTATION = SET_TRANSPORTATION;
function SET_RNF_TOTAL_PRICE(state) {
    var totalPrice = 0;
    for (var _i = 0, _a = state.rnfTransportations; _i < _a.length; _i++) {
        var singleTransportation = _a[_i];
        totalPrice += singleTransportation.referencePrice;
    }
    state.rnfTotalPrice = totalPrice;
}
exports.SET_RNF_TOTAL_PRICE = SET_RNF_TOTAL_PRICE;
// cache a price differ amount for the currently selected air connection
function SET_PRICE_DIFFER(state, differ) {
    state.priceDiffer = differ;
}
exports.SET_PRICE_DIFFER = SET_PRICE_DIFFER;
// export everything compliant to the vuex specification for mutations
exports.default = {
    IMPORT_AIRPORTS: IMPORT_AIRPORTS, IMPORT: IMPORT, SET_LOADING: SET_LOADING,
    SET_GATEWAYS_CACHE_FOR: SET_GATEWAYS_CACHE_FOR,
    SELECT_AIRPORT: SELECT_AIRPORT, RESET_STATE: RESET_STATE, RESET_SELECTED_FLIGHT: RESET_SELECTED_FLIGHT,
    SELECT_FLIGHT: SELECT_FLIGHT, SELECT_FLIGHT_CLASS: SELECT_FLIGHT_CLASS, SELECT_FLIGHT_DIRECTION: SELECT_FLIGHT_DIRECTION,
    SET_STEP: SET_STEP, RESET_RNF_STATE: RESET_RNF_STATE, SET_RNF_ARRIVAL: SET_RNF_ARRIVAL, SET_RNF_DEPARTURE: SET_RNF_DEPARTURE,
    SET_RNF_CATEGORY: SET_RNF_CATEGORY, SET_RNF_TOTAL_PRICE: SET_RNF_TOTAL_PRICE,
    SET_TRANSPORTATION: SET_TRANSPORTATION, SET_FETCH_TIME: SET_FETCH_TIME, RESET_STATE_TO_CHOOSE_STEP: RESET_STATE_TO_CHOOSE_STEP,
    SET_OR_TOGGLE_AIRLINE_CODE: SET_OR_TOGGLE_AIRLINE_CODE, SET_NONSTOP: SET_NONSTOP,
    SET_PRICE_DIFFER: SET_PRICE_DIFFER
};
//# sourceMappingURL=mutations.js.map